<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="银行名称" prop="bankName">
                <a-input v-model="queryParam.bankName" :maxLength="32" :placeholder="$t('请输入')+'银行名称'" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="银行卡号" prop="accountNo">
                <a-input v-model="queryParam.accountNo" :maxLength="32" :placeholder="$t('请输入')+'账号 银行卡,微信,支付宝'" allow-clear/>
              </a-form-item>
            </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="状态" prop="status">
                  <a-select :placeholder="$t('请选择')+'状态'" style="width: 100%" v-model="queryParam.status" allowClear>
                    <a-select-option v-for="(item, index) in customDict.WithdrawStatusEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="账户类型" prop="balanceType">
                <a-select :placeholder="$t('请选择')+'账户类型'" style="width: 100%" v-model="queryParam.balanceType" allowClear>
                  <a-select-option v-for="(item, index) in customDict.BalanceAccountTypeEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                                 :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                                 :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <a-alert
        type="warning"
        show-icon
        style="margin-bottom: 16px"
        message="当前未对接微信、支付宝商家转账，提现由后台手动线下打款。请先完成线下打款，再审核通过。"
      />
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport" v-hasPermi="['user:withdrawapply:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <audit-form
        ref="AuditForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="balanceType" slot-scope="text, record">
          <custom-dict-tag :options="customDict.BalanceAccountTypeEnum" :color="true" :value="record.balanceType"/>
        </span>
        <span slot="withdrawType" slot-scope="text, record">
          <custom-dict-tag :options="customDict.WithdrawTypeEnum" :color="true" :value="record.withdrawType"/>
        </span>
        <template slot="arriveImg" slot-scope="text, record">
          <div>
            <img v-if="record.arriveImg" :src="record.arriveImg" style="width:60px;height:62px;" @click="handleRecordPreview(record.arriveImg)" alt="none"/>
          </div>
        </template>
        <template slot="accountImg" slot-scope="text, record">
          <div>
            <img v-if="record.accountImg" :src="record.accountImg"  style="width:60px;height:60px;" @click="handleRecordPreview(record.accountImg)" alt="none"/>
          </div>
        </template>
        <span slot="status" slot-scope="text, record">
          <custom-dict-tag :options="customDict.WithdrawStatusEnum" :color="true" :value="record.status"/>
        </span>
        <span slot="isSuccess" slot-scope="text, record">
          <custom-dict-tag :options="customDict.TFEnum" :color="true" :color-array="['green','red']" :value="record.isSuccess"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['user:withdrawapply:edit']" />
          <a @click="$refs.AuditForm.handleAudit(record.id, undefined)" v-if="record.status===1" v-hasPermi="['user:withdrawapply:audit']">
             <a-icon type="edit" />{{$t('审核')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageWithdrawApply,listWithdrawApply, delWithdrawApply } from '@/api/user/withdraw'
import CustomDictTag from "@/components/DictCustomTag";
import AuditForm from "./AuditForm.vue";
import {mapGetters} from 'vuex'
import moment from 'moment';
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'WithdrawApply',
  components: {
    CustomDictTag,
    AuditForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        bankName: undefined,
        accountNo: undefined,
        withdrawType: undefined,
        summary: undefined,
        status: undefined,
        isSuccess: undefined,
        payStatus: undefined,
        payFailMessage: undefined,
        arriveTime: undefined,
        withdrawInfo: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '用户手机号',
          dataIndex: 'mobile',
          align: 'center'
        },
        {
          title: '账户类型',
          dataIndex: 'balanceType',
          scopedSlots: { customRender: 'balanceType' },
          align: 'center'
        },
        {
          title: '提现金额',
          dataIndex: 'amount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '账户名',
          dataIndex: 'accountName',
          align: 'center'
        },
        {
          title: '银行卡号',
          dataIndex: 'accountNo',
          align: 'center'
        },
        {
          title: '账户图片',
          dataIndex: 'accountImg',
          scopedSlots: { customRender: 'accountImg' },
          align: 'center'
        },
        {
          title: '方式',
          dataIndex: 'withdrawType',
          scopedSlots: { customRender: 'withdrawType' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: '是否成功',
          dataIndex: 'isSuccess',
          scopedSlots: { customRender: 'isSuccess' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '失败信息原因',
          dataIndex: 'payFailMessage',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '转账凭证',
          dataIndex: 'arriveImg',
          scopedSlots: { customRender: 'arriveImg' },
          align: 'center'
        },
        {
          title: '提现到账时间',
          dataIndex: 'arriveTime',
          scopedSlots: { customRender: 'arriveTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询提现申请记录列表 */
    getList () {
      this.loading = true
      pageWithdrawApply(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        bankName: undefined,
        accountNo: undefined,
        withdrawType: undefined,
        summary: undefined,
        status: undefined,
        isSuccess: undefined,
        payStatus: undefined,
        payFailMessage: undefined,
        arriveTime: undefined,
        withdrawInfo: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delWithdrawApply(that.ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message,3)
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/user/withdraw/apply/export',
            that.queryParam
            , `提现申请记录_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
